/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
var IS_MOBILE = $(window).width() < 768,
 IS_SMALL_DEVICE = $(window).width() < 992,
 _lat,
 _lng;

 function loadFacebookPixelTrackingContactEvent() {
  if (customProps.ENVIRONMENT === 'prod') {
    console.log('loading Contact event');
    fbq('track', 'Contact');
    return false;
  }
 }
 function loadFacebookPixelTrackingFindLocationEvent() {
  if (customProps.ENVIRONMENT === 'prod') {
   console.log('loading FindLocation event');
   fbq('track', 'FindLocation');
   return false;
  }
 }
 function loadFacebookPixelTrackingInitiateCheckoutEvent() {
  // not included yet because we cannot add it on the boxshop events
  if (customProps.ENVIRONMENT === 'prod') {
   console.log('loading InitiateCheckout event');
   fbq('track', 'InitiateCheckout');
   return false;
  }
 }
 function loadFacebookPixelTrackingLeadEvent() {
  if (customProps.ENVIRONMENT === 'prod') {
   console.log('loading Lead event');
   fbq('track', 'Lead');
   return false;
  }
 }
 function loadFacebookPixelTrackingPurchaseEvent(value = 0.00) {
  if (customProps.ENVIRONMENT === 'prod') {
   console.log('loading Purchase event');
   fbq('track', 'Purchase', {value, currency: 'AUD'});
   return false;
  }
 }
 function loadFacebookPixelTrackingViewContentEvent() {
  // this function is called dinamically by some services like Free Storage Move-In Service on the Wordpress side and single-service.php
  if (customProps.ENVIRONMENT === 'prod') {
   console.log('loading ViewContent event');
   fbq('track', 'ViewContent');
   return false;
  }
 }

$(document).ready(function() {
  //  FAQ
  $('.faq .question').on('click', function(e) {
    e.preventDefault();
    const contentHeight =
      $(this).parents('.faq').find('.answer p').height() + 20;

    if ($(this).parents('.faq').hasClass('open')) {
      $(this).parents('.faq').removeClass('open');
      $(this).parents('.faq').find('.answer').height(0);
    } else {
      $('.faq').removeClass('open');
      $('.faq').find('.answer').height('0');
      $(this).parents('.faq').addClass('open');
      $(this).parents('.faq').find('.answer').height(contentHeight);
    }
  });

  $('.input-faq').on('change', function() {
    let url = this.value;
    window.location.href = url;
    return false;
  });

  // Pay account
  $('.pay-account-select').on('change', function() {
    let a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    a.href = $(this).val();
    a.click();
    document.body.removeChild(a);
    //window.open($(this).val(), "_blank");
  });

  // Tabs
  var initTabs = function() {
    var tabContainer = $('.tab-container');
    if (tabContainer) {
      tabContainer
        .find('.tab-links-container a:first-child')
        .addClass('active');
      tabContainer
        .find('.tab-content-container .tab:first-child')
        .addClass('active');

      $('.btn-tab').on('click', function() {
        tabContainer.find('.active').removeClass('active');
        let tabId = $(this).data('tab-id');
        $(this).addClass('active');
        $(tabId).addClass('active');
        return false;
      });

      $('.input-tab').on('change', function() {
        tabContainer.find('.active').removeClass('active');
        let tabId = this.value;
        $(this).addClass('active');
        $(tabId).addClass('active');
        return false;
      });
    }
  };

  // hides the banner
  $('.close-icon, .close-icon span').click(function() {
    $('.bannerMessage').hide();
    // updates the cookie
    $.ajax({
      url: '/wp-content/themes/rent-a-space/includes/header-banner-cookie.php',
      dataType: 'json'
    });
  });

  $('.mobile-nav-icon').click(function() {
    $('.header').toggleClass('open-mobile-nav');
    $('body').toggleClass('open-nav');
    $('html').toggleClass('open-nav');
  });

  $('.mobile-nav__subnav > a').click(function(e) {
    e.preventDefault();

    $(this).parents('.mobile-nav__subnav').addClass('open-subnav');
    $(this).parents('.mobile-nav').addClass('open-subnav-container');
  });

  $('.mobile-nav__subnav .back').click(function(e) {
    e.preventDefault();

    $(this).parents('.mobile-nav__subnav').removeClass('open-subnav');
  });

  initTabs();
});

$(window).scroll(function() {}); //missing );
